import React from 'react';
import styled from 'styled-components';

import { red, blue, black, green } from 'utils/style/colors';
import APopover from '../APopover';

type ActionLinkTypes = React.HTMLAttributes<HTMLSpanElement> &
  React.HTMLAttributes<HTMLAnchorElement>;

interface IActionLinkProps extends ActionLinkTypes {
  href?: string;
  size?: number;
  color?: Colors;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  children: React.ReactNode | string;
}

export type Colors = 'blue' | 'red' | 'green' | 'black' | 'white' | 'disabled';

const setColor = {
  red,
  blue,
  black,
  green,
  white: 'var(--exact-white)',
  disabled: 'gray',
};

export const A = styled('a')<IActionLinkProps>`
  color: ${(props) => (props.color ? setColor[props.color] : black)};
  display: inline-flex;
  position: relative;
  font-size: ${(props) => props.size && `${props.size}px`};
  font-weight: 500;
  cursor: pointer;
`;

const ActionLink: React.FC<IActionLinkProps> = React.forwardRef<
  React.AnchorHTMLAttributes<HTMLAnchorElement>,
  IActionLinkProps
>(({ href, children, title, ...restProps }, ref) => {
  const body = href ? (
    <A ref={ref as any} href={href} {...restProps}>
      {children}
    </A>
  ) : (
    <A ref={ref as any} as="span" {...restProps}>
      {children}
    </A>
  );
  if (title) {
    return (
      <APopover arrow curveBorder target={body} placement="top" trigger="hover">
        <div>{title}</div>
      </APopover>
    );
  } else return body;
});

export default React.memo(ActionLink);
